import styled from "styled-components";
import FailedIcon from "./FailedIcon";
import PassedIcon from "./PassedIcon";
import PublishedIcon from "./PublishedIcon";
import WarningIcon from "./WarningIcon";
import ReviewIcon from "../actions/ReviewIcon";
import RunIcon from "../actions/RunIcon";

const JobStatusWrapper = styled.div`
  .status {
    display: inline-flex;
    align-items: center;
    padding: 4.5px 13px;
    border-radius: 24px;
    gap: 4px;
    font-size: 12px;
    font-weight: 400;
    line-height: 150%;
    width: 100px;
    justify-content: center;
  }
  .running-status {
    background: rgba(18, 203, 103, 0.1);
    color: #12cb67;
  }
  .review-status {
    color: #f2ab01;
    background: rgba(242, 171, 1, 0.1);
  }
  .published-status {
    color: #3d9cf5;
    background: rgba(49, 123, 235, 0.1);
  }
  .passed-status {
    color: #12cb67;
    background: rgba(18, 203, 103, 0.1);
  }
  .warning-status {
    color: #f2ab01;
    background: rgba(242, 171, 1, 0.1);
  }
  .failed-status {
    color: #f20f01;
    background: rgba(242, 15, 1, 0.1);
  }
`;

const JobStatus = ({ content, type }: { content: string; type?: string; className?: string }) => {
  let icon = null;
  let className = "status ";
  let title = "";

  switch (content) {
    case "RUNNING":
      icon = <RunIcon />;
      className += "running-status";
      title = "Job is running";
      break;
    case "FAILED":
      icon = <FailedIcon />;
      className += "review-status ";
      title = type === "job" ?
        "Job did not sucessfully execute":
        "QA check failed";
      break;
    case "REVIEW":
      icon = <ReviewIcon />;
      className += "review-status ";
      title = "Job is finished and results are ready for review";
      break;
    case "PUBLISHED":
      icon = <PublishedIcon />;
      className += "published-status";
      title = "Job has been published";
      break;
    case "PASSED":
      icon = <PassedIcon />;
      className += "passed-status";
      title = "QA check passed";
      break;
    case "WARNING":
      icon = <WarningIcon />;
      className += "warning-status";
      title = "QA check may require further review";
      break;
  }

  return (
    <JobStatusWrapper>
      <div className={className} title={title}>
        {icon} {content}
      </div>
    </JobStatusWrapper>
  );
};

export default JobStatus;
